import { TAB } from '../constants';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    Plan: {
        id: 'Components.InsurancePicker.Placeholder.Plan',
        defaultMessage: 'insurance plan',
    },
    Carrier: {
        id: 'Components.InsurancePicker.Placeholder.Carrier',
        defaultMessage: 'insurance carrier',
    },
    CarrierAndPlan: {
        id: 'Components.InsurancePicker.Placeholder.CarrierAndPlan',
        defaultMessage: 'insurance carrier and plan',
    },
});

export function getPlaceholder(tab, intl) {
    switch (tab) {
        case TAB.PLAN:
            return intl.formatMessage(messages.Plan);
        case TAB.BCBS:
            return intl.formatMessage(messages.Carrier);
        default:
            return intl.formatMessage(messages.CarrierAndPlan);
    }
}
